
function updateGlobalSteams(quantity, steams) {
  if (typeof Alpine === 'undefined') return;
  const store = Alpine.store('global');
  if (!store) return;
  store.CurrentQuantity = quantity;
  store.CurrentSteams = steams;
}

document.addEventListener('alpine:init', () => {
  updateGlobalSteams(1, 4);
});

document.addEventListener("DOMContentLoaded", function() {
  // Assuming Gadget is defined elsewhere
  window.api = new Gadget();

  const submitButton = document.getElementById('ProductSubmitButton-steams');
  if (!submitButton) return;

  // Make the event listener function async to use await inside it
  submitButton.addEventListener('click', async function(event) {
      try {
        const quantityInput = document.getElementById('Quantity-steams');
        let quantitySteams = parseInt(quantityInput.value, 10);

        let currentValue = parseInt(quantityInput.value, 10);
        totalPrice = productPrice * currentValue;
      
        const result =  await api.AddToCartSteam({
          product: currentProductId.toString() ,
          steams:quantitySteams,
          newPrice:totalPrice
        });

        console.log("Variant for Steams: " + result);

        const idFull = result;
        const idNumber = idFull.match(/(\d+)$/)[0];
        console.log(idNumber);


        const savedSelections = JSON.parse(localStorage.getItem('relatedProductsSelection')) || [];

        const promises = [];

        for (let i = 0; i < savedSelections.length; i++) {
          const product = savedSelections[i].replace(/"/g, '');
          console.log("Producto " + product);
          promises.push(addToCartWrapper(product, 1));
        }
      
        // Agrega el producto adicional
        promises.push(addToCartWrapper(idNumber, 1));
      
        try {
          await Promise.all(promises);
          console.log('All items added to cart successfully.');
          window.location.href = '/checkout';
        } catch (error) {
          console.error('One or more items failed to add to cart:', error);
        }
        console.log(result);

        
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
      
    });
});

function steamAdd() {
    const quantityInput = document.getElementById('Quantity-steams');
    if (!quantityInput) return;
    let currentValue = parseInt(quantityInput.value, 10); // Convertir a entero
    const newSteamsVal = currentValue + 1;
    quantityInput.value = newSteamsVal;
    updateGlobalSteams(1, newSteamsVal);
  }
  
function steamLess(){
    const quantityInput = document.getElementById('Quantity-steams');
    if (!quantityInput) return;
    let currentValue = parseInt(quantityInput.value, 10); // Convertir a entero

    if(currentValue>4){
      const newSteamsVal = currentValue - 1;
      quantityInput.value = newSteamsVal;
      updateGlobalSteams(1, newSteamsVal);
    }
}